(function (window, document, $, undefined) {

  $(function () {
    const header = document.querySelector(".site-header");
    const headroom = new Headroom(header);
    headroom.init();
    /**
     * Open mobile menu
     */
    $('.jsOffcanvasMenuToggler').on('click', function (e) {
      e.preventDefault();
      $('.jsOffcanvasMenu').toggleClass('is_active');
      $('body').toggleClass('is_open', $('.jsOffcanvasMenu').hasClass('is_active'));
      $('.offcanvas-menu__nav .sub-menu').slideUp();
      $('.offcanvas-menu__nav li.menu-item-has-children > a').removeClass('is_open');
    });

    /**
     * Append open button to mobile menu
     */
    $('.offcanvas-menu__nav li.menu-item-has-children').each(function (navListItem) {
      const subMenuButton = document.createElement('button');
      subMenuButton.innerHTML = '<span class="visuallyhidden">Show sub menu items</span>';
      subMenuButton.classList.add('menu-item__open-sub-menu');

      $('> a', this).after(subMenuButton);
    });

    /**
     * Open mobile sub menus
     */
    $('.offcanvas-menu__nav li.menu-item-has-children > button').on('click', function (e) {
      e.preventDefault();
      $(this).parent().find('.sub-menu').slideToggle();
      $(this).parent().toggleClass('is_open');
    });

    /**
     * Capabilities Carousel
     */
    $('.jsCapabilitiesCarouselWrapper').each(function () {

      var $wrapper = $(this);
      var $mainSlider = $wrapper.find('.jsCapabilitiesCarousel');
      var $nav = $wrapper.find('.jsCapabilitiesCarouselNav');
      // console.log($nav);

      $mainSlider.slick({
        dots: true,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        swipe: true,
        draggable: true,
        responsive: [
          {
            breakpoint: 500,
            settings: {
              dots: false,
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 768,
            settings: {
              dots: false,
              slidesToShow: 1.5,
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: 2,
            }
          }
        ]
      });

      // $mainSlider.slick('slickNext');

      $nav.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $mainSlider.slick($(this).data('dir'));
      });

      var numberOfItems = $mainSlider.find("ul.slick-dots li").length;
      var dotsManager = new ClassDotsManager($(this), numberOfItems, 4);

      dotsManager.init();
      dotsManager.updateDots(0);

      $mainSlider.on("afterChange", function (slick, currentSlide) {
        var numberOfItems = $mainSlider.find("ul.slick-dots li").length;
        var dotsManager = new ClassDotsManager($(this), numberOfItems, 4);
        dotsManager.updateDots(currentSlide.currentSlide);
      });

    });

    function ClassDotsManager(slickElementClass, numOfItems, numOfDots) {
      this.listDotsElement = slickElementClass.find("ul.slick-dots li");
      this.numOfDots = numOfDots <= numOfItems ? numOfDots : numOfItems;
      this.minIndex = 0;
      this.maxIndex = numOfDots - 1;
      this.showDotsBetween = function (minIndex, maxIndex) {
        this.listDotsElement.filter(function (index) {
          if (index >= minIndex && index <= maxIndex) {
            $(this).fadeIn();
          } else {
            $(this).css('display', 'none');
          }
        });
      };
      this.init = function () {
        this.showDotsBetween(0, this.numOfDots - 1);
      };
      this.updateDots = function (newIndex) {
        if (newIndex < this.maxIndex) {
          this.maxIndex = numOfDots - 1;
          this.minIndex = 0;
          this.showDotsBetween(this.minIndex, this.maxIndex);
        } else if (newIndex >= this.maxIndex && newIndex < numOfItems) {
          this.maxIndex = newIndex + 1;
          // + cast bool to 1 or 0
          this.minIndex =
            newIndex - numOfDots + (+(newIndex < numOfItems - 1) + 1);
          this.showDotsBetween(this.minIndex, this.maxIndex);
        }
      };
    }

    /**
     * Projects Carousel
     */
    $('.jsProjectsCarouselWrapper').each(function () {
      var $wrapper = $(this);
      var $mainSlider = $wrapper.find('.jsProjectsCarousel');
      var $nav = $wrapper.find('.jsProjectsCarouselNav');
      var $section = $wrapper.closest('.section');

      $mainSlider.slick({
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        swipe: true,
        draggable: true,
        autoplay: true,
        autoplaySpeed: 4000,
      });

      // $mainSlider.slick('slickNext');

      $nav.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $mainSlider.slick($(this).data('dir'));
      });

      // On slide change, go to the respective slide for the target carousel
      if ($section.find('.jsHomeProjectsCarousel').length > 0) {
        var $targetCarousel = $section.find('.jsHomeProjectsCarousel');

        // On before slide change
        $mainSlider.on(
          "beforeChange",
          function (event, slick, currentSlide, nextSlide) {
            $targetCarousel.slick('slickGoTo', nextSlide);
          }
        );
      }
    });

    /**
     * Clients Carousel
     */
    $('.jsClientsCarouselWrapper').each(function () {

      var $wrapper = $(this);
      var $mainSlider = $wrapper.find('.jsClientsCarousel');
      var $nav = $wrapper.find('.jsClientsCarouselNav');
      // console.log($nav);

      $mainSlider.slick({
        dots: true,
        arrows: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: false,
        swipe: true,
        draggable: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              dots: false,
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
            }
          },
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: 5,
            }
          },
        ]
      });

      // $mainSlider.slick('slickNext');

      $nav.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $mainSlider.slick($(this).data('dir'));
      });


      var numberOfItems = $mainSlider.find("ul.slick-dots li").length;
      var dotsManager = new ClassDotsManager($(this), numberOfItems, 4);

      dotsManager.init();
      dotsManager.updateDots(0);

      $mainSlider.on("afterChange", function (slick, currentSlide) {
        var numberOfItems = $mainSlider.find("ul.slick-dots li").length;
        var dotsManager = new ClassDotsManager($(this), numberOfItems, 4);
        dotsManager.updateDots(currentSlide.currentSlide);
      });


    });

    $('.fancybox-video-popup').fancybox({
      youtube: {
        showinfo: 0
      }
    });


    // /**
    //  * Make header blue on scroll
    //  */
    //  $(window).scroll(function(){
    // 	var header = $('.site-header'),
    // 		scroll = $(window).scrollTop();

    // 	if (scroll >= 60) header.addClass('is_scrolled');
    // 	else header.removeClass('is_scrolled');
    //   });


    /**
       * Testimonials Carousel
       */

    $('.jsImageCarouselWrapper').each(function () {

      var $wrapper = $(this);
      var $slider = $wrapper.find('.jsImageCarousel');
      var $nav = $wrapper.find('.jsImageCarouselArrow');
      var altClass = 'js-image-carousel-alt';

      $slider.slick({
        rows: 0,
        dots: true,
        appendDots: $wrapper.find('.js-nav-arrows-group-dots'),
        arrows: false,
        slidesToShow: $slider.hasClass(altClass) ? 1 : 2,
        slidesToScroll: 1,
        infinite: true,
        fade: $slider.hasClass(altClass),
        cssEase: 'ease-in-out',
        adaptiveHeight: true,
        speed: 500,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              dots: false,
              slidesToShow: 1,
            }
          },
        ]
      });

      $nav.on('click', function (e) {
        e.preventDefault();
        $slider.slick($(this).data('dir'));
      });
    });

    /**
     * Header Banner Carousel
     */

    $('.jsBannerCarouselWrapper').each(function () {

      var $wrapper = $(this);
      var $slider = $wrapper.find('.jsBannerCarousel');

      $slider.slick({
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        fade: true,
        cssEase: 'linear',
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 3500,
        pauseOnHover: false,
      });


    });


    //breadcrumbs

    var breadcrumbs = $('#breadcrumbs');
    if (breadcrumbs.length > 0) {
      var separators = breadcrumbs.find('.breadcrumb-separator');
      separators[2].style.backgroundColor = '#fff'
      // separators[2].addClass('last');
    }
  });

  $('.jsHomeProjectsCarousel').each(function () {
    $(this).slick({
      dots: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      swipe: false,
      draggable: false,
      fade: true,
      cssEase: 'linear',
      speed: 500,
    });
  });

  /**
   * Expand filters
   */
  $(function () {
    const activeClass = 'is-active';
    const $trigger = $('.js-expand-filters-trigger');
    const $body = $('.js-expand-filters-body');

    $trigger.on('click', function () {
      $trigger.toggleClass(activeClass);
      $body.slideToggle();
    });
  });

  /**
   * Accordion
   */
  $(function () {
    const activeClass = 'is-active';
    const slideDuration = 400;
    const $item = $('.js-accordion-item');
    const $trigger = $('.js-accordion-trigger');

    const removeActive = (item) => {
      if (item.hasClass(activeClass)) {
        item.removeClass(activeClass).children('.js-accordion-body').stop().slideUp(slideDuration);
        item.children('.accordion__header').children($trigger).attr('aria-expanded', false);
      }
    };

    $trigger.on('click', function () {
      const thisItem = $(this).closest($item);
      const isActive = thisItem.hasClass(activeClass);

      // remove active class from this item
      removeActive(thisItem);

      // remove active class from item siblings
      thisItem.siblings().each(function () {
        removeActive($(this));
      });

      // if the current item is not active, make it active
      if (!isActive) {
        thisItem.addClass(activeClass).children('.js-accordion-body').stop().slideToggle(slideDuration, function () {
          thisItem.children('.accordion__header').children($trigger).attr('aria-expanded', true);
        });
      }
    });
  });

})(window, document, jQuery);
